// extracted by mini-css-extract-plugin
export default {"skipLink":"skipLink---HhjPQ","skipLink__icon":"skipLink__icon---CpTWi"};